<template>
  <va-card stripe="info" :title="$t('events.activeClients')">
    <template slot="actions">
      <va-button color="info" @click="createClient()" icon="fa fa-plus"/>
      <va-button color="info" to="/admin/clients" icon="fa fa-eye"/>
    </template>
    <ClientCreateModal @closemodal="closeClient" @update="updateClient" :location-id="locationId" :open-modal="clientCreate"/>
    <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input
          class="ma-0"
          :value="term"
          :placeholder="$t('tables.searchByName')"
          @input="search"
          removable
        >
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :loading="loading"
      hoverable
    >
      <template slot="icon">
        <va-icon name="fa fa-user" color="secondary" />
      </template>
      <template v-slot:charge="props">
        {{props.rowData.charge}} {{currencySign}}
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import debounce from 'lodash/debounce'
import ClientCreateModal from '../modals/ClientCreateModal'

export default {
  name: 'ClientsLocationTable',
  components: { ClientCreateModal },
  data () {
    return {
      clientCreate: false,
      clients: [].slice(),
      loading: false,
      term: null,
      mode: 0,
    }
  },
  props: {
    lclients: Array,
    locationId: Number,
  },
  computed: {
    currencySign () {
      return this.$store.getters.theCurrency.currencySign
    },
    fields () {
      return [{
        name: '__slot:icon',
        width: '30px',
        dataClass: 'text-center',
      }, {
        name: 'ticket',
        title: 'ticket',
        width: '20%',
      },
      {
        name: 'spotIdentifier',
        title: 'spot',
        width: '20%',
      }, {
        name: '__slot:charge',
        title: 'charge',
        width: '20%',
      }, {
        name: 'period',
        title: 'period',
        width: '20%',
      }, {
        name: 'status',
        title: 'status',
        width: '20%',
      }]
    },
    modeOptions () {
      return [{
        value: 0,
        label: this.$t('dashboard.table.brief'),
      }]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.clients
      }

      return this.clients.filter(item => {
        return item.name.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods: {
    createClient () {
      this.clientCreate = true
    },
    closeClient (state) {
      this.clientCreate = state
    },
    updateClient (client) {
      this.clients.splice(this.clients.length, -1, client)
    },
    getStatusColor (status) {
      if (status === 'paid') {
        return 'success'
      }

      if (status === 'processing') {
        return 'info'
      }

      return 'danger'
    },
    resolveUser (user) {
      this.loading = true

      setTimeout(() => {
        const idx = this.clients.findIndex(u => u.id === user.id)
        this.clients.splice(idx, 1)
        this.loading = false

        this.showToast(this.$t('dashboard.table.resolved'), {
          icon: 'fa-check',
          position: 'bottom-right',
          duration: 1500,
        })
      }, 500)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
  mounted () {
    this.clients = this.lclients.slice()
  },
}
</script>

<style lang="scss">
</style>
